import { call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  ADD_AUTOMATION,
  DELETE_AUTOMATION,
  FETCH_AUTOMATION_CUSTOMERS,
  FETCH_AUTOMATION_LIST,
  UPDATE_AUTOMATION,
  UPDATE_AUTOMATION_FLAG,
  UPDATE_AUTOMATION_NAME,
  addAutomationFail,
  addAutomationSuccess,
  deleteAutomationFail,
  deleteAutomationSuccess,
  fetchAutomationCustomersFail,
  fetchAutomationCustomersSuccess,
  fetchAutomationListFail,
  fetchAutomationListSuccess,
  updateAutomationFail,
  updateAutomationFlagFail,
  updateAutomationFlagSuccess,
  updateAutomationNameFail,
  updateAutomationNameSuccess,
  updateAutomationSuccess,
  setAutomationPrioritySuccess,
  setAutomationPriorityFail,
  SET_AUTOMATION_PRIORITY,
  SAVE_AUTOMATION,
  saveAutomationSuccess,
  saveAutomationFail
} from '../../redux/actions/cm/automation';
import {
  SAVE_AUTOMATION_CUSTOMERS,
  saveAutomationCustomersFail,
  saveAutomationCustomersSuccess
} from '../../redux/actions/cm/automationCustomers';
import {
  addAutomation,
  deleteAutomation,
  fetchAutomationCustomers,
  fetchAutomationList,
  setAutomationPriority,
  saveAutomationCustomers,
  updateAutomation,
  updateAutomationEnabledFlag,
  updateAutomationName
} from '../../services/cm/automation';

function* fetchAutomationListWorker() {
  try {
    const { automationSettings: automationList, typologyActions } = yield call(
      fetchAutomationList
    );
    yield put(fetchAutomationListSuccess({ automationList, typologyActions }));
  } catch (error) {
    yield put(fetchAutomationListFail(error.message));
  }
}

export function* watchFetchAutomationList() {
  yield takeEvery(FETCH_AUTOMATION_LIST, function* () {
    yield fork(fetchAutomationListWorker);
  });
}

function* addAutomationWorker({ automationData }) {
  try {
    yield call(addAutomation, { automationData });
    yield put(addAutomationSuccess());
  } catch (error) {
    yield put(addAutomationFail(error.message));
  }
}

export function* watchAddAutomation() {
  yield takeEvery(ADD_AUTOMATION, function* ({ payload: { automationData } }) {
    yield fork(addAutomationWorker, { automationData });
  });
}

function* saveAutomationWorker({ automationData }) {
  try {
    const { itemsUpdated } = yield call(addAutomation, { automationData });
    yield put(saveAutomationSuccess({ id: itemsUpdated }));
  } catch (error) {
    yield put(saveAutomationFail(error.message));
  }
}

export function* watchSaveAutomation() {
  yield takeEvery(SAVE_AUTOMATION, function* ({ payload: { automationData } }) {
    yield fork(saveAutomationWorker, { automationData });
  });
}

function* updateAutomationWorker({ id, configData }) {
  try {
    yield call(updateAutomation, { id, configData });
    yield put(updateAutomationSuccess());
  } catch (error) {
    yield put(updateAutomationFail(error.message));
  }
}

export function* watchUpdateAutomation() {
  yield takeEvery(
    UPDATE_AUTOMATION,
    function* ({ payload: { id, configData } }) {
      yield fork(updateAutomationWorker, { id, configData });
    }
  );
}

function* updateAutomationNameWorker({ id, name }) {
  try {
    yield call(updateAutomationName, { id, name });
    yield put(updateAutomationNameSuccess());
  } catch (error) {
    yield put(updateAutomationNameFail(error.message));
  }
}

export function* watchUpdateAutomationName() {
  yield takeEvery(
    UPDATE_AUTOMATION_NAME,
    function* ({ payload: { id, name } }) {
      yield fork(updateAutomationNameWorker, { id, name });
    }
  );
}

function* updateAutomationEnabledFlagWorker({ id, enabled }) {
  try {
    yield call(updateAutomationEnabledFlag, { id, enabled });
    yield put(updateAutomationFlagSuccess());
  } catch (error) {
    yield put(updateAutomationFlagFail(error.message));
  }
}

export function* watchUpdateAutomationEnabledFlag() {
  yield takeEvery(
    UPDATE_AUTOMATION_FLAG,
    function* ({ payload: { id, enabled } }) {
      yield fork(updateAutomationEnabledFlagWorker, { id, enabled });
    }
  );
}

function* deleteAutomationWorker({ id }) {
  try {
    yield call(deleteAutomation, { id });
    yield put(deleteAutomationSuccess());
  } catch (error) {
    yield put(deleteAutomationFail(error.message));
  }
}

export function* watchDeleteAutomation() {
  yield takeEvery(DELETE_AUTOMATION, function* ({ payload: { id } }) {
    yield fork(deleteAutomationWorker, { id });
  });
}

function* setPriorityFlagWorker({ priorityList }) {
  try {
    yield call(setAutomationPriority, { priorityList });
    yield put(setAutomationPrioritySuccess());
  } catch (error) {
    yield put(setAutomationPriorityFail(error.message));
  }
}

export function* watchSetPriority() {
  yield takeEvery(
    SET_AUTOMATION_PRIORITY,
    function* ({ payload: { priorityList } }) {
      yield fork(setPriorityFlagWorker, { priorityList });
    }
  );
}

function* fetchAutomationCustomersWorker({ automationId }) {
  try {
    const { customerIds } = yield call(fetchAutomationCustomers, {
      automationId
    });
    yield put(fetchAutomationCustomersSuccess({ customersList: customerIds }));
  } catch (error) {
    yield put(fetchAutomationCustomersFail(error.message));
  }
}

export function* watchFetchAutomationCustomers() {
  yield takeEvery(
    FETCH_AUTOMATION_CUSTOMERS,
    function* ({ payload: { automationId } }) {
      yield fork(fetchAutomationCustomersWorker, { automationId });
    }
  );
}

function* saveAutomationCustomersWorker({
  automationId,
  customerIds,
  deleteCustomerIds
}) {
  try {
    yield call(saveAutomationCustomers, {
      automationId,
      customerIds,
      deleteCustomerIds
    });
    yield put(saveAutomationCustomersSuccess());
  } catch (error) {
    yield put(saveAutomationCustomersFail(error.message));
  }
}

export function* watchSaveAutomationCustomers() {
  yield takeEvery(
    SAVE_AUTOMATION_CUSTOMERS,
    function* ({ payload: { automationId, customerIds, deleteCustomerIds } }) {
      yield fork(saveAutomationCustomersWorker, {
        automationId,
        customerIds,
        deleteCustomerIds
      });
    }
  );
}
